import React, { useEffect } from 'react'
import { Wrapper, SpinnerWrapper } from './Landing.style'
import TopSection from './TopSection'
import { Spinner } from 'components'
import MiddleSection from './MiddleSection'
import BottomSection from './BottomSection'
import Footer from './Footer'
import { useDispatch } from 'react-redux'
import { fetchLandings, fetchFeaturedProducts } from '../store/actions'
import { useLandingLoading } from '../store/hooks'

const Landing = () => {
  const dispatch = useDispatch()
  const isLoading = useLandingLoading()
  useEffect(() => {
    dispatch(fetchFeaturedProducts())
    dispatch(fetchLandings())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <Wrapper>
      {isLoading && (
        <SpinnerWrapper>
          <Spinner size="big" />
        </SpinnerWrapper>
      )}
      <TopSection />
      <MiddleSection />
      <BottomSection />
      <Footer />
    </Wrapper>
  )
}

export default Landing
